<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre3" id="calibre_pb_0"></div>
<p class="p_norm-center__and__page_break1" id="auto_bookmark_toc_1"><span>To Michael. For encouraging me to write, allowing me to pursue my dreams, and always being there when I needed you. This book and all the others are for you. Forever is not long enough.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?2eff7abd